import React from "react";
import styled from "styled-components";
import { theme } from "../../theme/theme";
import { Arrow } from "../Assets";
import { PageSection } from "../PageSection";
import { Link } from "../Link";

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  .btn {
    border-color: ${theme.accent};
    color: ${theme.accent};
    path {
      fill: ${theme.accent};
    }
  }
  @media screen and (max-width: 460px) {
    flex-direction: column;
    width: 100%;
    .btn {
      width: 100%;
    }
  }
`;

interface ChangeSectionProps {
  title: string;
  label: string;
  linkTo: string;
}

export const CtaSection = (props: ChangeSectionProps) => {
  return (
    <Section className="Cta">
      <div className="flex container padding space-between">
        <div className="Content flex col align-center text-center">
          <Title>{props.title}</Title>
          <ButtonsContainer>
            <Link to={props.linkTo} className="btn">
              {props.label}
              <Arrow />
            </Link>
          </ButtonsContainer>
        </div>
      </div>
    </Section>
  );
};

const Title = styled.h2`
  margin-top: 0px;
  margin-bottom: 40px;
  max-width: 770px;
`;

const Section = styled(PageSection)`
  display: flex;
  background-color: rgba(59, 42, 93, 0.1);
  width: 100%;
  .Content {
    flex: 3 1 300px;
  }
  .cta-body {
    margin-bottom: 40px;
    max-width: 880px;
    a {
      text-decoration: underline;
    }
  }
`;
